import { useCallback, useEffect, useState } from 'react';
import {
  getPendingAccountDeletions,
  recoverPendingAccountDeletions
} from '../services/accountDeletion';

export function useAccountDeletionRecovery(user) {
  const [pendingDeletions, setPendingDeletions] = useState([]);
  const [recoveryMessage, setRecoveryMessage] = useState('');

  const retryPendingDeletions = useCallback(async () => {
    if (!user) return;
    try {
      const results = await recoverPendingAccountDeletions(user);
      const remaining = getPendingAccountDeletions();
      setPendingDeletions(remaining);
      setRecoveryMessage(
        remaining.length
          ? results.find(item => !item.complete && !item.discarded)?.result?.error?.message ||
            results.find(item => item.error && !item.discarded)?.error?.message ||
            'Some account deletions still need recovery.'
          : ''
      );
    } catch (error) {
      setRecoveryMessage(error.message || 'Saved account-deletion recovery could not be loaded.');
    }
  }, [user]);

  useEffect(() => {
    if (user) retryPendingDeletions();
  }, [user, retryPendingDeletions]);

  return {
    pendingDeletions,
    recoveryMessage,
    retryPendingDeletions
  };
}
